function Event({ dimensions, col = '#000' }) {
  const baseXml = `
    <svg width=${dimensions || '24'} height=${(dimensions * 7) / 6 || '28'} viewBox="0 0 24 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M21.3333 3.33366H20V0.666992H17.3333V3.33366H6.66667V0.666992H4V3.33366H2.66667C1.2 3.33366 0 4.53366 0 6.00033V24.667C0 26.1337 1.2 27.3337 2.66667 27.3337H21.3333C22.8 27.3337 24 26.1337 24 24.667V6.00033C24 4.53366 22.8 3.33366 21.3333 3.33366ZM21.3333 24.667H2.66667V11.3337H21.3333V24.667ZM2.66667 8.66699V6.00033H21.3333V8.66699H2.66667ZM10.08 22.6137L17.9867 14.707L16.5733 13.2937L10.08 19.787L7.26667 16.9737L5.85333 18.387L10.08 22.6137Z" fill=${`"${col}"`}/>
    </svg>

  `;
  return baseXml;
}

export default Event;
